import React from "react";
import { MapPin, Phone } from "lucide-react";
import { Link } from "react-router-dom";
import Logo from "./Logo";
import { useI18n } from "../lib/i18n";

export default function SiteFooter() {
  const { t } = useI18n();
  return (
    <footer data-testid="site-footer" className="border-t border-[#35353B] bg-[#101114] py-8">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 flex flex-col md:flex-row md:items-start justify-between gap-6">
        <div className="space-y-2">
          <Logo size="sm" />
          <div className="text-xs text-[#A8A8AD]">© 2026 MQL Group. All rights reserved.</div>
          <div className="flex gap-4 text-xs pt-1">
            <Link to="/policy/buyer" data-testid="footer-buyer-policy" className="text-[#D4AF37] hover:underline">{t("policy.buyer")}</Link>
            <Link to="/policy/supplier" data-testid="footer-supplier-policy" className="text-[#D4AF37] hover:underline">{t("policy.supplier")}</Link>
          </div>
        </div>
        <div data-testid="footer-contact" className="text-xs text-[#A8A8AD] space-y-2 max-w-md">
          <div className="font-bold uppercase tracking-[0.2em] text-[#D4AF37]">{t("footer.contact")}</div>
          <div data-testid="footer-address" className="flex gap-2">
            <MapPin size={14} className="text-[#D4AF37] shrink-0 mt-0.5" />
            <span>Jl. Pasir Honje No. 08, RT 01/RW 01, Kelurahan Padasuka, Kecamatan Cimenyan, Kabupaten Bandung, Jawa Barat 40191.</span>
          </div>
          <div data-testid="footer-phone" className="flex gap-2">
            <Phone size={14} className="text-[#D4AF37] shrink-0 mt-0.5" />
            <span>{t("footer.phone")}: 085720370707</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
